import { Layout, theme } from "antd";

import Text from "@components/Text";
import { SIDEBAR_WIDTH } from "@components/Constants";
import { useConsoleStore } from "@components/Store";
import { useLayoutTopOffset, ReleaseAlert } from "@components/Page";

import Sidebar from "./Sidebar";
import ConsoleLayoutOutlet from "./ConsoleLayoutOutlet.js";
import { ADMINISTRATOR_MENU_ITEMS } from "./Sidebar/helpers/menuItems";
import { SecondFactorAlert } from "../../backstage/index.js";

const LABEL_INITIALIZE = "Initializing...";


const ConsoleLayout = () => {
  const { token } = theme.useToken();
  const { colorBgContainer } = token;

  const layoutTopOffset = useLayoutTopOffset();
  const { isReady, context: consoleContext } = useConsoleStore();

  if (!isReady) {
    return <Text text={LABEL_INITIALIZE} />;
  }

  const layoutProps = {
    style: {
      marginLeft: SIDEBAR_WIDTH,
      background: colorBgContainer,
    },
  };

  const context = {
    layoutTopOffset,
    ...consoleContext,
  };

  return (
    <>
      <Sidebar items={ADMINISTRATOR_MENU_ITEMS} />

      <Layout {...layoutProps}>
        <ReleaseAlert />
        <SecondFactorAlert />

        <Layout.Content>
          <ConsoleLayoutOutlet context={context} />
        </Layout.Content>
      </Layout>
    </>
  );
};

export default ConsoleLayout;
